// extracted by mini-css-extract-plugin
export default {"headerBar":"mH-z","pointsSection":"nH-z","goToDashboard":"oH-z"};